<script setup lang="ts">
import {computed} from "vue";
import type {ICellRendererParams} from "ag-grid-community";

interface IconMapping {
  when: string;
  icon: string;
  color?: string;
}

const props = defineProps<{ params: ICellRendererParams & {rendererOptions?: any; colId?: string} }>();

function resolveColId(): string | undefined {
  return props.params.colId ?? props.params.column?.getColId();
}

const cell = computed(() => {
  const data: any = props.params.data;
  const colId = resolveColId();
  if (!data || !colId) return null;
  return data.cells?.[colId] ?? null;
});

const opts = computed<{ mapping: IconMapping[]; position: 'prefix' | 'replace' }>(() => {
  const ctx = props.params.rendererOptions?.icon ?? {};
  return {
    mapping: Array.isArray(ctx.mapping) ? ctx.mapping : [],
    position: ctx.position === 'replace' ? 'replace' : 'prefix',
  };
});

const cellValueString = computed(() => String(cell.value?.value ?? props.params.value ?? '').trim());

const matchedIcon = computed<IconMapping | null>(() => {
  for (const m of opts.value.mapping) {
    if (m.when === cellValueString.value) return m;
  }
  return null;
});

const displayText = computed(() => cell.value?.displayValue ?? String(cell.value?.value ?? props.params.value ?? ''));
</script>

<template>
  <span class="bi-icon-cell">
    <q-icon v-if="matchedIcon"
            :name="matchedIcon.icon"
            :style="{color: matchedIcon.color ?? 'inherit'}"
            size="18px"
            class="bi-icon-mark"/>
    <span v-if="opts.position === 'prefix' || !matchedIcon">{{ displayText }}</span>
  </span>
</template>

<style scoped>
.bi-icon-cell {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.bi-icon-mark {
  flex-shrink: 0;
}
</style>
